// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2u2mZ","rootSuccess":"CompleteLink_rootSuccess__3CVz9","rootFailure":"CompleteLink_rootFailure__2ZwN9","isDisabled":"CompleteLink_isDisabled__2qEap"};